var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    {
      staticClass: "reports-listing-table-row",
      nativeOn: {
        click: function($event) {
          return _vm.handleClickRow($event)
        }
      }
    },
    [
      _vm._l(_vm.columns, function(column) {
        return [
          column.code === "name"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: column.maxWidth } },
                [
                  _c(
                    "div",
                    { staticClass: "reports-listing-table-row__cell--name" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-semibold"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.report.name) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.report.new
                        ? _c("CompassFlag", {
                            attrs: {
                              label: _vm.$t.__("common.labels.new"),
                              size: "small"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "category"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: {
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [
                  _vm.showCategory
                    ? _c("CompassTag", { attrs: { color: _vm.getColorTag } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getLabelCategory) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }